import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { AccordionIndexType, useAccordion } from './accordion-context'

import * as styles from './accordion.module.scss'

type Props = React.ComponentProps<'div'> & {
  index?: AccordionIndexType
}

export const AccordionContent = ({
  children,
  className,
  index,
  ...props
}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const [isOpen] = useAccordion()
  const active = index === isOpen

  /**
   * Set fixed content height on mount side effect
   *
   * On initial render we rely on css height: auto to display initial expanded content.
   * After content is mounted into DOM, set a fixed height using a number, to make animations work.
   */
  const [height, setHeight] = useState<number | string>(active ? 'auto' : 0)
  useEffect(() => {
    if (ref.current && active) {
      setHeight(ref.current.scrollHeight)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={styles.content}
      style={{ height: active ? ref.current?.scrollHeight || height : 0 }}
      {...props}
    >
      <div className={clsx(styles.inner, className)}>{children}</div>
    </div>
  )
}
